import JobSearchToolbarItem from './JobSearchToolbarItem';
import React from 'react';
import JobSortToolbarItem from './JobSortToolbarItem';

const JobFilterToolbar = () => {
    return <div className="flex gap-1">
        <JobSearchToolbarItem />
        <JobSortToolbarItem/>
    </div>;
};

export default JobFilterToolbar;
